import type { SiteConfig } from '../../@types/context/site-config.types';
import { contactAxoNoConfig } from './contact-axo-no.config';

export const contactZmartaNoConfig: Pick<SiteConfig, 'contact'> =
  contactAxoNoConfig;
